import { render } from "./gestione.vue?vue&type=template&id=8e3e0944&ts=true"
import script from "./gestione.vue?vue&type=script&lang=ts"
export * from "./gestione.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__